import { IconComponent } from "./icon";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { type FC } from "react";

const Copy: FC<{ value?: string }> = ({ value = "" }) => {
  return (
    <CopyToClipboard text={value}>
      <IconComponent name="copy" />
    </CopyToClipboard>
  );
};

export default Copy;
